import { connect } from 'react-redux';
import { Subheader } from './Subheader';
import { State } from 'store/state';
import { routeSelector } from 'store/state/selectors/router';

const mapStateToProps = (state: State) => ({
  route: routeSelector(state),
});

export default connect(mapStateToProps)(Subheader);
